var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12:55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.55016 21.75C16.6045 21.75 21.5583 14.2467 21.5583 7.74189C21.5583 7.53095 21.5536 7.31533 21.5442 7.10439C22.5079 6.40749 23.3395 5.54428 24 4.55533C23.1025 4.95463 22.1496 5.21541 21.1739 5.32877C22.2013 4.71294 22.9705 3.7455 23.3391 2.6058C22.3726 3.17859 21.3156 3.58264 20.2134 3.80064C19.4708 3.01159 18.489 2.48915 17.4197 2.31408C16.3504 2.13902 15.2532 2.32108 14.2977 2.83213C13.3423 3.34317 12.5818 4.15474 12.1338 5.14134C11.6859 6.12795 11.5754 7.23465 11.8195 8.29033C9.86249 8.19212 7.94794 7.68373 6.19998 6.79813C4.45203 5.91252 2.90969 4.66947 1.67297 3.14955C1.0444 4.23327 0.852057 5.51568 1.13503 6.73612C1.418 7.95657 2.15506 9.02348 3.19641 9.72002C2.41463 9.6952 1.64998 9.48471 0.965625 9.10595V9.16689C0.964925 10.3042 1.3581 11.4066 2.07831 12.2868C2.79852 13.167 3.80132 13.7706 4.91625 13.995C4.19206 14.1932 3.43198 14.222 2.69484 14.0794C3.00945 15.0575 3.62157 15.9129 4.44577 16.5264C5.26997 17.1398 6.26512 17.4806 7.29234 17.5013C5.54842 18.8711 3.39417 19.6142 1.17656 19.6106C0.783287 19.61 0.390399 19.5859 0 19.5385C2.25286 20.9838 4.87353 21.7514 7.55016 21.75Z",
    fill: "#242424"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12:55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0d9f3f45883d6a61f1990723a59a96b4.svg";
export { ForwardRef as ReactComponent };